"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletConnectProviderFactory = void 0;
const sdk_wallet_connect_provider_1 = require("@multiversx/sdk-wallet-connect-provider");
const AuthProviders_1 = require("../AuthProviders");
const network_1 = require("../network");
const EventBus_1 = __importDefault(require("../EventBus"));
class WalletConnectProviderFactory {
    constructor(env, projectId) {
        this.networkOptions = network_1.network[env];
        this.projectId = projectId;
    }
    createProvider() {
        let walletConnectProvider;
        const eventBus = new EventBus_1.default();
        const provider = new sdk_wallet_connect_provider_1.WalletConnectV2Provider({
            onClientLogin: () => eventBus.emit("login", {}),
            onClientLogout: () => eventBus.emit("logout", {}),
            onClientEvent: (event) => eventBus.emit(event.name, event.data),
        }, this.networkOptions.chainId, this.networkOptions.relayAddress, this.projectId);
        walletConnectProvider = new AuthProviders_1.WalletConnectProvider(provider, eventBus);
        return walletConnectProvider;
    }
}
exports.WalletConnectProviderFactory = WalletConnectProviderFactory;
